import App from 'app'
import { TextEditor } from 'components/input'
import React, { useEffect, useState } from 'react'
import Select from "react-select"
import { GetUser } from 'services/Session'
import { GetSetting, SetSetting } from 'services/Setting'

export function ProductForm(props) {
  const user = GetUser()
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [setting, setSetting] = useState({
    "address": '',
    "description": '',
    "courier.code": '',
    "facebook_url": '',
    "instagram_url": '',
    "whatsapp_url": '',
    "instagram_post_url": '',
    "about": '',
    "terms": '',
    "privacy": '',
  })

  function setData(key, value) {
    if (setting[key] !== value) {
      setSetting({ ...setting, [key]: value })
    }
  }

  useEffect(() => {
    const getData = async () => {
      await GetSetting(setSetting)
    }
    getData()
  }, [])

  const inputClass = [
    'bg-gray-50',
    'block',
    'border',
    'border-gray-300',
    'p-2.5',
    'rounded-md',
    'w-full',
    'dark:bg-gray-700',
    'dark:border-gray-600',
    'dark:focus:border-sky-500',
    'dark:focus:ring-sky-500',
    'dark:placeholder-gray-400',
    'dark:text-white',
    'focus:border-sky-500',
    'focus:ring-sky-500',
  ].join(' ')

  const options = [
    {value: 'male', label: 'Pakaian Pria'},
    {value: 'female', label: 'Pakaian Wanita'},
    {value: 'kitab', label: 'Buku & Kitab'},
    {value: 'other', label: 'Lain-lain'},
  ]

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault()
    try {
      const res = await SetSetting(setting)
      alert(res?.data?.message?? 'Pengaturan web berhasil diperbarui.')
    } catch (e) {
      setErrorMessage(e?.response?.data?.error?.message?? 'Gagal terhubung ke server, silakan coba lagi nanti.')
      setTimeout(() => {
        setErrorMessage('')
      }, 3000)
    }
    setLoading(false)
  }

  return (
    <App user={user} setting={setting}>
      <div className='p-4'>
        {errorMessage && (
          <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-6 py-3 rounded-md shadow-md flex items-center" style={{zIndex: 9999}}>
            <span>{errorMessage}</span>
            <button className="ml-4 text-white focus:outline-none" onClick={() => setErrorMessage('')}>✖</button>
          </div>
        )}
        <div className="mx-auto mt-10 p-4 bg-white rounded-lg shadow-md w-full md:w-3/4">
          <h3 className="font-bold leading-tight tracking-tight text-center mb-4">
            Tambah Produk
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" action="#">
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <label className="block mb-2 font-medium dark:text-white">Tipe</label>
                <Select 
                  placeholder="Pilih tipe produk..."
                  // value={setting.tos} 
                  onChange={(values) => { setData('courier.code', values ? values.map(val => val.value).join(',') : '') }} 
                  options={[
                    {value: 'ready_stock', label: 'Ready Stock'},
                    {value: 'pre_order', label: 'Pre Order'},
                    {value: 'ticket', label: 'e-Ticket'},
                    {value: 'certificate', label: 'Syahadah'},
                  ]}
                  styles={{
                  control: (baseStyles, _state) => ({
                    ...baseStyles,
                    backgroundColor: 'rgb(249 250 251 / 1)',
                    padding: 2,
                    borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
                    borderRadius: '0.375rem',
                  }),
                  }}
                />
              </div>
              <div>
                <label className="block mb-2 font-medium dark:text-white">Kategori</label>
                <Select 
                  placeholder="Pilih kategori produk..."
                  // value={setting.tes} 
                  onChange={(values) => { setData('courier.code', values ? values.map(val => val.value).join(',') : '') }} 
                  options={options}
                  styles={{
                  control: (baseStyles, _state) => ({
                    ...baseStyles,
                    backgroundColor: 'rgb(249 250 251 / 1)',
                    padding: 2,
                    borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
                    borderRadius: '0.375rem',
                  }),
                  }}
                />
              </div>
            </div>
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Nama Produk</label>
                <input onChange={(e) => setData('instagram_url', e.target.value)} value={''}  name="instagram_url" id="instagram_url" className={inputClass}/>
              </div>
              <div>
                <label htmlFor="facebook_url" className="block mb-2 font-medium dark:text-white">SKU</label>
                <input onChange={(e) => setData('facebook_url', e.target.value)} value={''}  name="facebook_url" id="facebook_url" className={inputClass}/>
              </div>
            </div>
            <div>
              <label htmlFor="description" className="block mb-2 font-medium dark:text-white">Deskripsi</label>
              <TextEditor text={''} setText={(val) => setData('description', val)} name="description" id="description" className={inputClass} />
            </div>
            <div className='grid grid-cols-4 gap-4'>
              <div>
                <label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Berat</label>
                <input placeholder='(kg)' onChange={(e) => setData('instagram_url', e.target.value)} value={''}  name="instagram_url" id="instagram_url" className={inputClass}/>
              </div>
              <div>
                <label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Panjang</label>
                <input placeholder='(cm)' onChange={(e) => setData('instagram_url', e.target.value)} value={''}  name="instagram_url" id="instagram_url" className={inputClass}/>
              </div>
              <div>
                <label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Lebar</label>
                <input placeholder='(cm)' onChange={(e) => setData('instagram_url', e.target.value)} value={''}  name="instagram_url" id="instagram_url" className={inputClass}/>
              </div>
              <div>
                <label htmlFor="instagram_url" className="block mb-2 font-medium dark:text-white">Tinggi</label>
                <input placeholder='(cm)' onChange={(e) => setData('instagram_url', e.target.value)} value={''}  name="instagram_url" id="instagram_url" className={inputClass}/>
              </div>
            </div>
          <div htmlFor="description" className="block mb-2 font-medium dark:text-white">Variasi</div>
          <div class="card border-0 mb-4">
            <div class="card-body">
              <div class="row mb-3 gx-3">
                <div class="col-4">
                  <input onChange={(e) => setData('instagram_url', e.target.value)} value={'Warna'}  name="instagram_url" id="instagram_url" className={inputClass}/>
                </div>
                <div class="col-7">
                  <Select 
                    isMulti
                    placeholder="Pilih warna..."
                    // value={setting.tos} 
                    onChange={(values) => { setData('courier.code', values ? values.map(val => val.value).join(',') : '') }} 
                    options={[
                      {value: 'ready_stock', label: 'Merah'},
                      {value: 'pre_order', label: 'Kuning'},
                      {value: 'ticket', label: 'Hijau'},
                      {value: 'certificate', label: 'Biru'},
                    ]}
                    styles={{
                    control: (baseStyles, _state) => ({
                      ...baseStyles,
                      backgroundColor: 'rgb(249 250 251 / 1)',
                      padding: 2,
                      borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
                      borderRadius: '0.375rem',
                    }),
                    }}
                  />
                </div>
                <div class="col-1">
                  <a href="#" class="btn btn-default d-block"><i class="fa fa-trash"></i></a>
                </div>
              </div>
              <div class="row mb-3 gx-3">
                <div class="col-4">
                  <input onChange={(e) => setData('instagram_url', e.target.value)} value={'Ukuran'}  name="instagram_url" id="instagram_url" className={inputClass}/>
                </div>
                <div class="col-7">
                  <Select 
                    isMulti
                    placeholder="Pilih ukuran..."
                    // value={setting.tos} 
                    onChange={(values) => { setData('courier.code', values ? values.map(val => val.value).join(',') : '') }} 
                    options={[
                      {value: 'ready_stock', label: 'XS'},
                      {value: 'pre_order', label: 'S'},
                      {value: 'ticket', label: 'M'},
                      {value: 'certificate', label: 'L'},
                    ]}
                    styles={{
                    control: (baseStyles, _state) => ({
                      ...baseStyles,
                      backgroundColor: 'rgb(249 250 251 / 1)',
                      padding: 2,
                      borderColor: 'rgba(var(--bs-gray-300-rgb), 1) !important',
                      borderRadius: '0.375rem',
                    }),
                    }}
                  />
                </div>
                <div class="col-1">
                  <a href="#" class="btn btn-default d-block"><i class="fa fa-trash"></i></a>
                </div>
              </div>
              <table class="table fw-bold">
                <thead>
                  <tr>
                    <th width="1%"></th>
                    <th>Varian</th>
                    <th width="75px">Foto</th>
                    <th width="150px">SKU</th>
                    <th width="150px">Harga</th>
                    <th width="150px">Jumlah</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="align-middle">
                      <div class="form-check">
                        <input type="checkbox" name="variant[0][enabled]" id="variant_0_enabled" value="1" checked class="form-check-input" />
                        <label class="form-check-label">&nbsp;</label>
                      </div>
                    </td>
                    <td class="fs-13px align-middle">
                      <span class="text-indigo">Black</span>
                      <span class="text-muted mx-1"> • </span>
                      <span class="text-dark">XS</span>
                    </td>
                    <td><a href="#" class="btn btn-white d-block">Upload</a></td>
                    <td><input type="text" class="form-control" value="" placeholder="#SKU000001" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0.00" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0" /></td>
                  </tr>
                  <tr>
                    <td class="align-middle">
                      <div class="form-check">
                        <input type="checkbox" name="variant[1][enabled]" id="variant_1_enabled" value="1" class="form-check-input" />
                        <label class="form-check-label">&nbsp;</label>
                      </div>
                    </td>
                    <td class="fs-13px align-middle">
                      <span class="text-indigo">Black</span>
                      <span class="text-muted mx-1"> • </span>
                      <span class="text-dark">S</span>
                    </td>
                    <td><a href="#" class="btn btn-white d-block">Upload</a></td>
                    <td><input type="text" class="form-control" value="" placeholder="#SKU000001" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0.00" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0" /></td>
                  </tr>
                  <tr>
                    <td class="align-middle">
                      <div class="form-check">
                        <input type="checkbox" name="variant[1][enabled]" id="variant_2_enabled" value="1" class="form-check-input" />
                        <label class="form-check-label">&nbsp;</label>
                      </div>
                    </td>
                    <td class="fs-13px align-middle">
                      <span class="text-indigo">Black</span>
                      <span class="text-muted mx-1"> • </span>
                      <span class="text-dark">M</span>
                    </td>
                    <td><a href="#" class="btn btn-white d-block">Upload</a></td>
                    <td><input type="text" class="form-control" value="" placeholder="#SKU000001" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0.00" /></td>
                    <td><input type="text" class="form-control" value="" placeholder="0" /></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
            <div className="grid gap-4 grid-flow-col justify-end">
              <button onClick={() => setView('view-profile')} type="button" className="px-4 py-2.5 text-gray-800 bg-gray-200 rounded-md hover:bg-gray-400">Batal</button>
              <button type="submit" className="text-white bg-sky-500 hover:bg-sky-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md px-4 py-2.5 text-center dark:bg-sky-500 dark:hover:bg-sky-700 dark:focus:ring-blue-800">
                {loading ? (
                  <svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                ) : (
                  "Simpan"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </App>
  )
}
